import { render, staticRenderFns } from "./headerNotice.vue?vue&type=template&id=6be603a2&scoped=true&"
import script from "./headerNotice.vue?vue&type=script&lang=js&"
export * from "./headerNotice.vue?vue&type=script&lang=js&"
import style0 from "./headerNotice.vue?vue&type=style&index=0&id=6be603a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be603a2",
  null
  
)

component.options.__file = "headerNotice.vue"
export default component.exports